module.exports = __webpack_public_path__ + "static/media/icon-arrivee.6336fd07.svg";